import get from 'lodash/get';
/**
 * Intl.NumberFormat doesn't format if amount is between 1000 and 9999.
 * It just returns digits together without separation to format like this: 1 000
 *
 * decimalsDisplay: DEFAULT means that display only when number has decimals
 * @returns numbers formated to for e.g. '1 000', '30 000'
 */
export var convertNumberToLocaleMoneyFormat = function (amount, options) {
    var _a, _b;
    var fractionDigits = (_a = get(options, 'fractionDigits')) !== null && _a !== void 0 ? _a : 2;
    var decimalsDisplay = (_b = get(options, 'decimalsDisplay')) !== null && _b !== void 0 ? _b : 'DEFAULT';
    var integerNumber = amount.toString();
    var floatingNumber = '';
    if (decimalsDisplay === 'FRACTION_FIXED') {
        integerNumber = amount.toFixed(fractionDigits);
    }
    if (decimalsDisplay === 'DEFAULT') {
        integerNumber = Math.round(amount).toString();
    }
    if (integerNumber.includes('.')) {
        floatingNumber = integerNumber.slice(integerNumber.indexOf('.') + 1);
        integerNumber = integerNumber.slice(0, integerNumber.indexOf('.'));
    }
    if (floatingNumber.length === fractionDigits - 1) {
        floatingNumber = "".concat(floatingNumber, "0");
    }
    var formatStringifiedNumber = function (stringifiedNumber, buildedNumberRightSide) {
        if (buildedNumberRightSide === void 0) { buildedNumberRightSide = ''; }
        if (stringifiedNumber.length > 3) {
            var slicedEnd = " ".concat(stringifiedNumber.slice(stringifiedNumber.length - 3));
            var rest = stringifiedNumber.slice(0, stringifiedNumber.length - 3);
            return formatStringifiedNumber(rest, slicedEnd + buildedNumberRightSide);
        }
        return stringifiedNumber + buildedNumberRightSide;
    };
    var formatedIntegerPart = formatStringifiedNumber(integerNumber);
    return !floatingNumber ? formatedIntegerPart : "".concat(formatedIntegerPart, ",").concat(floatingNumber);
};
